import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="onboarding-checklist"
export default class extends Controller {
  static targets = ["dismissButton"]
  static values = {
    dismissUrl: String
  }

  connect() {
    console.log("Onboarding checklist controller connected")
    console.log("Dismiss URL:", this.dismissUrlValue)

    // Fallback: add click listener directly if action binding fails
    if (this.hasDismissButtonTarget) {
      this.dismissButtonTarget.addEventListener("click", (e) => this.dismiss(e))
    }
  }

  async dismiss(event) {
    event.preventDefault()
    event.stopPropagation()

    console.log("Dismiss button clicked")

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    if (!csrfToken) {
      console.error("CSRF token not found")
      this.showNotification("Security token not found. Please refresh the page.", "error")
      return
    }

    try {
      const response = await fetch(this.dismissUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      console.log("Response status:", response.status)

      if (response.ok) {
        console.log("Checklist dismissed successfully")
        this.showNotification("Checklist dismissed successfully!", "success")
        this.fadeOutAndRemove()
      } else {
        const errorText = await response.text()
        console.error("Failed to dismiss checklist. Status:", response.status, "Response:", errorText)
        this.showNotification("Failed to dismiss checklist. Please try again.", "error")
      }
    } catch (error) {
      console.error("Error dismissing checklist:", error)
      this.showNotification("An error occurred. Please try again.", "error")
    }
  }

  fadeOutAndRemove() {
    this.element.style.transition = "opacity 0.3s ease-out, transform 0.3s ease-out"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-10px)"

    setTimeout(() => {
      this.element.remove()
    }, 300)
  }

  showNotification(message, type) {
    if (typeof window.showNotification === "function") {
      window.showNotification(message, type, 3000)
    } else {
      // Fallback: create a simple toast notification
      const toast = document.createElement("div")
      toast.className = `fixed top-4 right-4 z-50 px-4 py-3 rounded-lg shadow-lg text-white ${
        type === "success" ? "bg-green-500" : "bg-red-500"
      }`
      toast.textContent = message
      document.body.appendChild(toast)

      setTimeout(() => {
        toast.style.transition = "opacity 0.3s"
        toast.style.opacity = "0"
        setTimeout(() => toast.remove(), 300)
      }, 3000)
    }
  }
}
